export default __webpack_public_path__ + "static/media/total-workforce-icon.c4f611b0.svg";